<template>
  <div class="modal-body">
    <button v-if="active === 'lista-observacao'" type="button" class="btn btn-outline-info m-1" @click.prevent="mudarComponent('salvar-observacao')">Nova Observação</button>
    <button v-if="active === 'salvar-observacao'" type="button" class="btn btn-outline-info m-1" @click.prevent="mudarComponent('lista-observacao')">Voltar</button>
    <div class="list-group mt-2">
      <component :key="active" v-bind:is="active" :numeroProcesso="numeroProcesso" :eventBusModal="eventBusModal" :voltar="() => mudarComponent('lista-observacao')"></component>
    </div>
  </div>
</template>

<script>
import lista from '@/components/observacoes/Lista'
import salvar from '@/components/observacoes/Salvar'

import eventBus from '@/uteis/eventBus'

export default {
  name: 'observacao',
  props: {
    numeroProcesso: { type: String, required: true }
  },

  components: {
    'lista-observacao': lista,
    'salvar-observacao': salvar
  },

  data () {
    return {
      active: 'lista-observacao',
      eventBusModal: 'fechar-modal'
    }
  },

  methods: {
    mudarComponent (component) {
      this.active = component
    }
  },

  mounted () {
    eventBus.$on(this.eventBusModal, () => {
      this.mudarComponent('lista-observacao')
    })
  }
}
</script>
